import { render, staticRenderFns } from "./ArchitectureLists.vue?vue&type=template&id=606fb54c&"
import script from "./ArchitectureLists.vue?vue&type=script&lang=js&"
export * from "./ArchitectureLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports